import React, {useContext, useEffect, useState} from "react";
import { ResponsiveLine } from '@nivo/line'
import '../../../styles/chart.css';
import {ViewContext} from "../../Context/ViewContext";
import {defaultMargin} from "@nivo/core";

export const LineChartCustom = ({data, dataBis, title, keysArray = [], labels = {}, height}) => {
	  const layout = "vertical", groupMode = "stacked", colors = "pastel1", fontSizeX = '11px';
    let keys = [];
    const { view } = useContext(ViewContext)
    const {label, labelSecond} = labels;

    const getHeight = () => {
        if (view == "simple") {
            return height ? height : '300px';
        } else {
            return height ? '400px' : '360px';
        }
    };
    
    if (!data || !data.some(item => item.data.length > 0)) {
        return (<div>No data</div>);
    }

    data.forEach(e => {
        keys.push(e.key)
    });

    const commonLineProps = {
        margin: {top: 20, right: 62, bottom: 70, left: 71},
        xScale: {type: 'point'},
        yScale: {
            type: 'linear',
            min: 'auto',
            max: 'auto',
            stacked: false,
            reverse: false
        },
        pointSize: 10,
        pointColor: {theme: 'background'},
        pointBorderWidth: 2,
        pointBorderColor: {from: 'serieColor'},
        pointLabel: "data.yFormatted",
        pointLabelYOffset: -12,
        enableTouchCrosshair: true,
        useMesh: true,
        legends: [
            {
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 85,
                translateY: 0,
                itemsSpacing: 0,
                itemDirection: 'left-to-right',
                itemWidth: 80,
                itemHeight: 20,
                itemOpacity: 0.75,
                symbolSize: 12,
                symbolShape: 'circle',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ],
    };

    const euroFormatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    return (
        <div className="lineContainer" style={{width: '48.3%', height: getHeight()}}>
            <span style={{textAlign: 'center', marginTop: "25px"}}>{title}</span>
            <div style={{height: '45%'}}>
            <ResponsiveLine
                data={data}
                {...commonLineProps}
                height={(view == "simple") ? 300 : 160}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: -45,
                    ...(label ? { legend: label } : {}),
                    legendOffset: 50,
                    legendPosition: 'middle',
                    truncateTickAt: 0
                }}
                tooltip={({ point }) => (
                    <div
                        style={{
                            background: 'white',
                            padding: '9px 12px',
                            border: '1px solid #ccc',
                            borderRadius: '5px'
                        }}
                    >
                        <p>
                            <svg style={{marginRight:'8px'}} width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                                <rect width="20" height="20" x="1" y="1" rx="2" ry="2" fill={point.serieColor}/>
                            </svg>
                            <span style={{fontWeight: 'bold'}}>{point.data.x}</span> : {euroFormatter.format(point.data.y)}
                        </p>
                    </div>
                )}
                axisLeft={{
                    tickSize: 5,
                    tickValues: 4,
                    tickPadding: 0,
                    tickRotation: 0,
                    legendOffset: -65,
                    legendPosition: 'middle',
                    truncateTickAt: 0,
                    format: (value) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + " €"
                }}
            />
            </div>
            <span style={{display: (view == "simple") ? 'none' : 'block', height: '50%'}}>
            <ResponsiveLine
                data={dataBis}
                {...commonLineProps}
                height={(view == "simple") ? 250 : 160}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: -45,
                    ...(labelSecond ? { legend: labelSecond } : {}),
                    legendOffset: 50,
                    legendPosition: 'middle',
                    truncateTickAt: 0
                }}
                axisLeft={{
                    tickSize: 5,
                    tickValues: 4,
                    tickPadding: 0,
                    tickRotation: 0,
                    legendOffset: -65,
                    legendPosition: 'middle',
                    truncateTickAt: 0,
                    format: (value) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + " €"
                }}
            />
            </span>
        </div>
    );
}



